module.exports = __webpack_public_path__ + "img/Group 7855.ea36bea2.svg";